import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IClient, QueryClient } from './Client.service';

export interface IMaterial {
	id?: number;
	name: string;
	value: string;
	price: string;
	isActive: boolean;
	client?: Partial<IClient>;
	createdAt?: Date;
	updatedAt?: Date;
	actions?: any;
}

abstract class MaterialService {
	static async getAll(
		params: QueryClient
	): Promise<PaginationContent<IMaterial> | undefined> {
		let isActive;
		if (params.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<IMaterial> = await request(
				'/materials',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		data: IMaterial,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'post');
	}

	static async edit(
		data: IMaterial,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'patch');
	}

	private static async createOrEdit(
		content: IMaterial,
		setError: React.Dispatch<React.SetStateAction<string>>,
		mode: 'post' | 'patch'
	) {
		try {
			const { id, client, value, price, createdAt, updatedAt, ...data } =
				content;
			const url = mode === 'post' ? '/materials' : `/materials/${id}`;
			const response = await request(url, mode, {
				data: {
					...data,
					value: Number(value),
					price: Number(price),
					idClient: client?.id,
				},
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}
}

export default MaterialService;
